module.exports = __webpack_public_path__ + "static/media/emotes.5e2f6ed8.png";